import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import { LoadingBarService } from '@ngx-loading-bar/core';
import swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/core/services/app.service';
import { ToastrService } from 'ngx-toastr';
import { EditPlanificationOfaComponent } from './edit-planification/edit-planification.component';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { LocalStorageService } from 'ngx-webstorage';
import { AppConfigService } from '../../../../core/services/config.service';

@Component({
  selector: 'app-declencher-ofa',
  templateUrl: './declencher-ofa.component.html',
  encapsulation: ViewEncapsulation.None,
  styles: [`
    .dark-modal .modal-content {
      background-color: #292b2c;
      color: white;
    }
    .dark-modal .close {
      color: white;
    }
    .light-blue-backdrop {
      background-color: #5cb3fd;
    }
`]
})

export class DeclencherOfaComponent implements OnInit {
  public libelle: string;
  public date_debut: any;
  public date_fin: any;
  public libelleAnnee: any;
  public annee: any;
  public idCampagne: any;
  public listCampagne: any;
  public key = 'libelle';
  public reverse = false;
  public p = 1;
  public filter: string;
  public day;
  public month;
  libelle_menu = 'Campagnes'

  constructor(
    private modalService: NgbModal,
    private title: Title,
    private storage: LocalStorageService,
    private toastrService: ToastrService,
    private http: HttpClient,
    private _loading: LoadingBarService,
    private _router: Router,
    public activeModal: NgbActiveModal,
    private _service: AppService,
    public configService: AppConfigService,
    private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.title.setTitle('Initialisation OFA | HR Performance');
    this.getCampagneActive();
    // this.getLastCampagneEia();
    this.getDateOfDay();
    // this.getLogs();
  }

  // Get logs
  getLogs() {
    this._service.getData('menus/' + this.libelle_menu + '/getUserInteractions').subscribe(data => { })
  }

  public getStatusClasses(statut: string): { [key: string]: boolean } {
    return {
      'badge-info': statut === 'executé' || statut === 'arbitré',
      'badge-danger': statut === 'clôturé' || statut === 'fermé',
      'badge-warning': statut === 'attente',
      'badge-effectue': statut === 'effectué',
      'badge-accepte': statut === 'accepté',
      'badge-planifie': statut === 'planifié',
      'badge-valide': statut === 'validé',
      'badge-approuve': statut === 'approuvé',
      'badge-revus': statut === 'revu',
      'badge-soumis': statut === 'soumis',
      'badge-success': statut === 'démarré' || statut === 'ouvert',
      'badge-100': statut !== 'planifié'
    };
  }

  public getDisplayStatut(statut: string): string {
    return statut === 'en attente' ? statut : `${statut}e`;
  }

  public editPlanificationCampagne(data) {
    const modalRef = this.modalService.open(EditPlanificationOfaComponent, {
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static',
      keyboard: false,
      centered: true,
    });
    modalRef.componentInstance.planification = data;
  }

  public getDateOfDay() {
    const d = new Date();
    const day = d.getDate();
    const month = d.getMonth() + 1;
    this.month = month;
    day < 10 ? this.day = '0' + day : this.day = day;
    month < 10 ? this.month = '0' + month : this.month = month;
    const year = d.getFullYear();
    this.date_debut = year + '-' + this.month + '-' + this.day;
    this.date_fin = year + '-' + this.month + '-' + this.day;
    this.annee = year;
  }

  public addCampagne(content) {
    this.activeModal = this.modalService.
      open(content, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false, centered: true });
  }

  public openCampagne(content) {
    this.activeModal = this.modalService.
      open(content, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false, centered: true });
  }

  public editOpenOfa(content) {
    this.activeModal = this.modalService.
      open(content, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false, centered: true });
  }

  public getLastCampagneEia() {
    this._service.getData('campagne/ofa/last_eia')
      .subscribe(
        res => {
          if (res.error === false) {
            this._loading.stop();
            this.libelleAnnee = res.data.libelle;
            this.annee = parseInt(res.data.annee);
            this.idCampagne = res.data.id;
          } else {
            const sigle = this.configService.get('SIGLE');
            let title;
            if (sigle === 'SMB') {
              title = 'HR PERF';
            } else if (sigle === 'SIR') {
              title = 'HR PERF';
            }
            swal.fire({
              title: title,
              type: 'error',
              text: res.message,
              showCancelButton: false,
              confirmButtonText: 'ok'
            });
          }
        },
        err => {
          this.toastrService.error(err.error.message);
          this._loading.stop();
        }
      );
  }

  public getListeAnnee() {
    this._service.getData('campagne/last')
      .subscribe(
        res => {
          if (res.error === false) {
            this._loading.stop();
            this.annee = res.data.annee;
            this.idCampagne = res.data.id;
          } else {
            const sigle = this.configService.get('SIGLE');
            let title;
            if (sigle === 'SMB') {
              title = 'HR PERF';
            } else if (sigle === 'SIR') {
              title = 'HR PERF';
            }
            swal.fire({
              title: title,
              type: 'error',
              text: res.message,
              showCancelButton: false,
              confirmButtonText: 'ok'
            });
          }
        },
        err => {
          this.toastrService.error(err.error.message);
          this._loading.stop();
        }
      );
  }

  public saveCampagne() {
    this._loading.start();
    const data = {
      'libelle': this.libelle,
      'annee': this.annee,
      'date_debut': this.date_debut,
      'date_fin': this.date_fin,
      'campagne_ofa_id': this.idCampagne
    }
    this._service.postData('gestion-ofas/campagnes/add', data)
      .subscribe(
        res => {
          if (res.error === false) {
            this.toastrService.success(res.message);
            this.rerender();
            this.activeModal.close();
            this._loading.stop();
            this.date_debut = '';
            this.date_fin = '';
            // this.getListeAnnee();
          } else {
            this.toastrService.error(res.message);
            this._loading.stop();
          }
        }, err => {
          this.toastrService.error(err.error.message);
        }
      );
  }

  public saveCampagneOld() {
    this._loading.start();
    const data = {
      // 'annee': this.annee,
      'campagne_ofa_id': this.idCampagne
    }
    this._service.postData('gestion-ofas/campagnes/add', data)
      .subscribe(
        res => {
          if (res.error === false) {
            this.toastrService.success(res.message);
            this.rerender();
            this.activeModal.close();
            this._loading.stop();
            this.getCampagneActive();
          } else {
            this.toastrService.error(res.message);
            this._loading.stop();
          }
        }, err => {
          this.toastrService.error(err.error.message);
        }
      );
  }

  public updateCampagne(date_debut, date_fin) {
    let myDateDebut, myDateFin, newDateDebut, newDateFin
    myDateDebut = date_debut.split('-');
    myDateFin = date_fin.split('-');
    newDateDebut = new Date(myDateDebut[0], myDateDebut[1], myDateDebut[2]);
    newDateFin = new Date(myDateFin[0], myDateFin[1], myDateFin[2]);
    if (newDateDebut.getTime() > newDateFin.getTime()) {
      this.toastrService.error('La date de fin doit être supérieure à la date de fin');
    } else {
      this._loading.start();
      const data = {
        'date_debut': date_debut,
        'date_fin': date_fin,
        'campagne_ofa_id': this.storage.retrieve('idCampagneOfaSelected')
      }
      this._service.postData('gestion-ofas/campagnes/update', data)
        .subscribe(
          res => {
            if (res.error === false) {
              this.toastrService.success(res.message);
              this.rerender();
              this.activeModal.close();
              this._loading.stop();
              this.getCampagneActive();
            } else {
              this.toastrService.error(res.message);
              this._loading.stop();
            }
          }, err => {
            this.toastrService.error(err.error.message);
          }
        );
    }
  }

  public fermerCampagne(item) {
    swal.fire({
      title: `Vous allez fermer la campagne ${item.libelle}`,
      text: 'cette action est irréversible !!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#FD7E14',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Non, Annuler!',
      confirmButtonText: 'Oui, fermer!'
    }).then((result) => {
      if (result.value) {
        this._loading.start();
        this._service.getData(`campagne/${item.id}/ofa/fermer`)
          .subscribe(
            res => {
              if (res.error === false) {
                this.toastrService.success(res.message);
                this.getCampagneActive();
                this._loading.stop();
              } else {
                this.toastrService.error(res.message);
                this._loading.stop();
              }
            }, err => {
              this._loading.stop();
              this.toastrService.error(err.error.message);
            }
          );
      }
    });
  }

  public ouvertureCampagne() {
    let myDateDebut = this.date_debut.split('-');
    let myDateFin = this.date_fin.split('-');
    let newDateDebut = new Date(myDateDebut[0], myDateDebut[1], myDateDebut[2]);
    let newDateFin = new Date(myDateFin[0], myDateFin[1], myDateFin[2]);
    if (newDateDebut.getTime() > newDateFin.getTime()) {
      this.toastrService.error('La date de fin doit être supérieure à la date de fin');
    } else {
      this._loading.start();
      const data = {
        'date_debut': this.date_debut,
        'date_fin': this.date_fin,
        'id': this.storage.retrieve('idCampagneOfaSelected')
      }
      this._service.postData('campagne/ofa/open', data)
        .subscribe(
          res => {
            if (res.error === false) {
              this.toastrService.success(res.message);
              this.rerender();
              this.activeModal.close();
              this._loading.stop();
              this.getCampagneActive();
            } else {
              this.toastrService.error(res.message);
              this._loading.stop();
            }
          }, err => {
            this.toastrService.error(err.error.message);
          }
        );
    }
  }

  public getCampagneActive() {
    this._service.getData('gestion-ofas/campagnes/ofa/all').subscribe(res => {
        if (res.error === false) {
            this.listCampagne = res['data'];
        }
    })
}

  public rerender() {
    this.getCampagneActive();
  }
}
